import { DateTime } from 'luxon';

export function formatDayKey(day: DateTime) {
  return day.weekdayLong.toLocaleLowerCase();
}
